module.exports = __webpack_public_path__ + "static/media/premise.c6084d27.svg";